var map = {
	"./BULLDOZER.svg": "e3e7",
	"./EXCAVATOR.svg": "4178a",
	"./FRONT_LOADER.svg": "c896",
	"./GOAL.svg": "1040",
	"./GRADER.svg": "89e2",
	"./HARVESTER.svg": "cf0b",
	"./QUAD.svg": "c70f",
	"./TRACTOR.svg": "e78a",
	"./TRAILER.svg": "fea0",
	"./TRUCK.svg": "f083",
	"./VEHICLE.svg": "73cf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";